import { useEffect, useState } from 'react'
import { Drawer } from 'antd'

import Box from '~/core/Box'
import { useFlagEnabled } from '~/lib/isFlagEnabled'
import { useEnableBusinessAccountTrialMutation } from '~/gql/graphql'

import DrawerTitle from './PreniunUpsellDrawerComponents/DrawerTitle'
import DrawerBody from './PreniunUpsellDrawerComponents/DrawerBody'
import UpsellForm from './PreniunUpsellDrawerComponents/UpsellForm'
import DrawerFooter from './OnBoardDrawer/DrawerFooter'
import PremiumTrialActivationBanner from './PremiumTrialActivationBanner'
import EmailNotVerified from './EmailNotVerifiedBanner'
import {
    EMAIL_NOT_VERIFIED,
    MISSING_SALESFORCE_ACCOUNT,
    PENDING_BA_INVITATION,
    PREMIUM_RETRIAL,
    PREMIUM_TRIAL_ACTIVATION_TITLE,
    PREMIUM_TRIAL_FLAGS,
    TRIAL_ACTIVATION_SUCCESS,
    USER_ADDED_TO_BUSINESS_ACCOUNT,
    USER_ADDED_TO_BUSINESS_ACCOUNT_TITLE,
} from './logic'
import PremiumTrialExpiredModal from './PremiumTrialExpiredModal'
type PremiumUpsellDrawerPropsType = {
    visible: boolean
    onClose: () => void
}

const WIDTH = 420

export default function PremiumUpsellDrawer(
    props: PremiumUpsellDrawerPropsType,
) {
    const { visible, onClose } = props
    const [subMenuVisible, setSubMenuVisible] = useState(false)
    const [trialActivated, setTrialActivated] = useState(false)
    const [emailNotVerified, setEmailNotVerified] = useState(false)
    const [userRequestingRetrial, setUserRequestingRetrial] = useState(false)
    const [isPremiumExpiredModalVisible, setPremiumExpiredModalVisible] =
        useState(false)
    const [userAddedToBusinessAccount, setUserAddedToBusinessAccount] =
        useState(false)
    const [enableBusinessAccountTrial, { data, loading }] =
        useEnableBusinessAccountTrialMutation()
    const isPremiumTrialFlagEnabled = useFlagEnabled(
        PREMIUM_TRIAL_FLAGS.PREMIUM_TRIAL_SELF_SERVE,
    )

    useEffect(() => {
        switch (data?.enableBusinessAccountTrial) {
            case TRIAL_ACTIVATION_SUCCESS:
                setTrialActivated(true)
                break
            case EMAIL_NOT_VERIFIED:
                setEmailNotVerified(true)
                break
            case USER_ADDED_TO_BUSINESS_ACCOUNT:
                setUserAddedToBusinessAccount(true)
                break
            case PENDING_BA_INVITATION:
            case MISSING_SALESFORCE_ACCOUNT:
                setSubMenuVisible(true)
                break
            case PREMIUM_RETRIAL:
                setUserRequestingRetrial(true)
                setPremiumExpiredModalVisible(true)
                onClose()
                break
        }
    }, [data])
    const renderUpsellTitle = () =>
        subMenuVisible ? <UpsellForm /> : <DrawerBody />

    const renderUpsellTrialFlowTitle = () => (
        <>
            {!(
                trialActivated ||
                userAddedToBusinessAccount ||
                emailNotVerified ||
                subMenuVisible
            ) && <DrawerBody />}
            {subMenuVisible && <UpsellForm />}
            {trialActivated && (
                <PremiumTrialActivationBanner
                    title={PREMIUM_TRIAL_ACTIVATION_TITLE}
                />
            )}
            {userAddedToBusinessAccount && (
                <PremiumTrialActivationBanner
                    title={USER_ADDED_TO_BUSINESS_ACCOUNT_TITLE}
                />
            )}
            {emailNotVerified && <EmailNotVerified />}
            {userRequestingRetrial && (
                <PremiumTrialExpiredModal
                    isPremiumTrialExpiredModalVisible={
                        isPremiumExpiredModalVisible
                    }
                    setPremiumTrialExpiredModalVisible={
                        setPremiumExpiredModalVisible
                    }
                />
            )}
        </>
    )

    return (
        <Drawer
            width={WIDTH}
            visible={visible}
            onClose={() => {
                onClose()
                if (
                    isPremiumTrialFlagEnabled &&
                    (userAddedToBusinessAccount || trialActivated)
                ) {
                    window.location.reload()
                }
            }}
            title={
                <DrawerTitle
                    subMenuVisible={subMenuVisible}
                    onClick={() => {
                        if (isPremiumTrialFlagEnabled && !subMenuVisible) {
                            enableBusinessAccountTrial()
                        } else {
                            setSubMenuVisible(!subMenuVisible)
                        }
                    }}
                    requestTrialLoading={loading}
                    requestTrialDisabled={emailNotVerified}
                    showTeamsEnabledTitle={
                        isPremiumTrialFlagEnabled &&
                        (userAddedToBusinessAccount || trialActivated)
                    }
                />
            }
            headerStyle={{ padding: '0px' }}
            bodyStyle={{ padding: '0px' }}
        >
            <Box direction="col" height="100%" justifyContent="between">
                {isPremiumTrialFlagEnabled
                    ? renderUpsellTrialFlowTitle()
                    : renderUpsellTitle()}
                <DrawerFooter />
            </Box>
        </Drawer>
    )
}
